import gql from 'graphql-tag';
import ProgramaUniversidadService from '@/views/pagos/services/programa-universidad.service';
import { getheadersrest } from '@/components/Utils';
import { query } from '@/views/oferta_academica/autoria/posgraditos/utils.js';

const MODULO_CERO_NOMBRE = 'Tecnologías de la Información y la Comunicación Transformación Digital';
const MODULO_FINAL_NOMBRE = 'Módulo de Titulacion';
const NOTA_APROBACION_DEFAULT = 71;
const MODALIDAD_ESAM_DEFAULT = 'V';
const PORTADA_DEV_DEFAULT = 'sinfotoentest.jpg';

const fmtDate = f => {
  if (!f) return null;
  const s = String(f).slice(0, 10);
  if (s.includes('/')) return s;
  const [y, m, d] = s.split('-');
  return y && m && d ? `${d}/${m}/${y}` : null;
};

const nombreCompuestoEsam = (postgrado, programa, programaUniv, row) => {
  const universidadId = programaUniv?.sedeUniversidad?.universidadId || row?.universidad_id || row?.universidadId || 'U';
  const nombre = postgrado.nombre
    .replaceAll('Diplomado DIPLOMADO', 'DIPLOMADO')
    .replaceAll('Especialidad ESPECIALIDAD', 'ESPECIALIDAD')
    .replaceAll('Maestría Maestría', 'MAESTRÍA')
    .replaceAll('Maestria Maestria', 'MAESTRÍA');
  return `${nombre} (V${programa.version} G${programa.grupo} ${programa.gestion} S${programa.sede_id} U${universidadId})`;
};

const modalidadProgramaUniversidad = programaUniv => programaUniv?.modalidad || 'teorico';

const mensajeError = error => {
  if (!error) return '';
  if (typeof error === 'string') return error;
  try {
    return JSON.stringify(error);
  } catch (e) {
    return String(error);
  }
};

const findModuloPortalName = async (thiz, nombre) => { 
  const sql = gql`query{ getModulos(cursor:10000000,nombre:"${nombre}"){ id,nombre,sigla,tipo } }`;
  const res = await thiz.$apollo.query({ query: sql }).then(({ data }) => data).catch(() => null);
  const modulos = res?.getModulos || [];
  
  const found = modulos.find(m => String(m.nombre).toLowerCase() === String(nombre).toLowerCase());
  if(!found){
    window.console.log('>>> findModuloPortalName', modulos, nombre, found);
  }
  return found || modulos[0] || null;
};

const createModuloPortal = async (thiz, nombre) => {
  const obj = { nombre, sigla: 'MOD-v2', tipo: 'NEW' };
  const sql = gql`mutation{ createModulo(input:${window.stringifyObject(obj)}){ok,modulo{id,nombre,sigla,tipo},errors{message}} }`;
  const res = await thiz.$apollo.mutate({ mutation: sql }).then(({ data }) => data).catch(() => null);
  window.console.log('createModuloPortal',nombre,res);
  
  return res?.createModulo?.ok ? res.createModulo.modulo : null;
};

const getOrCreateModuloPortal = async (thiz, nombre) => {
  let modulo = await findModuloPortalName(thiz, nombre); 
  if (modulo?.id) return modulo;
  await createModuloPortal(thiz, nombre);
  modulo = await findModuloPortalName(thiz, nombre);
  window.console.log('modulo nombremoddd 2',nombre,modulo);
  return modulo;
};

const getOrCreatePostgrado = async (thiz, row) => { 

  let area_id = 1
  const area_idpu = row.areaUniversidad ? row.areaUniversidad.id : 1
  if(area_idpu == 1) area_id = 1
  else if(area_idpu == 3) area_id = 4
  else if(area_idpu == 5) area_id = 6
  else if(area_idpu == 6) area_id = 10
  else if(area_idpu == 7) area_id = 12 

  let cate = 1;
  const name = row.programaNombre.toLowerCase();
  if( name.includes('diplomado') ) cate = 1
  else if( name.includes('especialidad') ) cate = 2
  else if( name.includes('maestria') || name.includes('maestría') ) cate = 3
 
  const s = query(1, row.programaNombre);
  const unidad = row.sede? row.sede.unidad_negocio : thiz.$store.state.CARGO.sede.unidad_negocio
  const sql = gql`${s}`;
  let encontrados = await thiz.$apollo.query({ query: sql })
    .then(({ data: { getPostgrados } }) => getPostgrados)
    .catch(() => []);

  if(!encontrados) encontrados = [];
  encontrados = encontrados.filter(x=>x.unidad_negocio_id == unidad) 
  
  let postgradoId = encontrados?.length ? encontrados[0].id : 0;
  if (!postgradoId) {
    const data = {
      idarea: area_id,
      idcategoria: cate,
      nombre: row.programaNombre,
      portada: 'portadita.jpg',
      creditaje: 1,
      duracion: 1,
      unidad_duracion: 1,
      carga_horaria: 1,
      unidad_negocio_id: unidad,
    };
    const mut = gql`mutation{ createPostgrado(input:${window.stringifyObject(data)}){ok,postgrado{id,nombre,unidad_duracion},errors{message}} }`;
    const res = await thiz.$apollo.mutate({ mutation: mut }).then(({ data }) => data).catch(() => null);
    if (res?.createPostgrado?.ok) postgradoId = res.createPostgrado.postgrado.id;
  }

  if (!postgradoId) return null;
  const q = gql`query{ getPostgrado(id:${postgradoId}){id,nombre,duracion,creditaje,unidad_negocio_id,status,carga_horaria,unidad_duracion,estado,portada,objetivo,dirigido,categoria{id nombre clase_netsuite_id}, area{id nombre}, clasenetsuite{id, nombre} } }`;
  return await thiz.$apollo.query({ query: q }).then(({ data }) => data.getPostgrado).catch(() => null);
};

const buildPlanes = (listasPreciosPorTipo) => {
  const planes = [];
  listasPreciosPorTipo.forEach(tipo => {
    tipo.modalidades.forEach(modalidad => {
      const nombre = `${tipo.tipoListaPrecio} - PLAN ${modalidad.modalidadPago.toUpperCase()}`;
      const esContado = nombre.toLowerCase().includes('contado');
      planes.push({
        tipo_plan_id: esContado ? 2 : 1,
        nombre,
        aprobado: false,
        estado: true,
        cobros: modalidad.conceptos.map(c => ({
          concepto_pago_id: c.conceptoPago.id,
          nombre_concepto: c.conceptoPago.nombre,
          monto: c.monto,
          cuotas: esContado ? (c.numeroCuotas > 2 ? 2 : c.numeroCuotas) : c.numeroCuotas,
        })),
      });
    });
  });
  return planes;
};

const buildModulos = async (thiz, modulosUniversidad) => {
  const modulos = [];
  const moduloCero = await getOrCreateModuloPortal(thiz, MODULO_CERO_NOMBRE);
  if (!moduloCero?.id) throw new Error(`No se pudo obtener el módulo cero: ${MODULO_CERO_NOMBRE}`);
  modulos.push({
    modulo_id: moduloCero.id,
    numero: 0,
    tipo_calificacion: 'Moodle y Sistema',
  });

  const ordenados = modulosUniversidad.slice().sort((a, b) => a.numero - b.numero);
  for (const m of ordenados) {
    const modulo = await getOrCreateModuloPortal(thiz, m.nombre);
    if (!modulo?.id) throw new Error(`No se pudo obtener el módulo portal: ${m.nombre}`);
    modulos.push({
      modulo_id: modulo.id,
      numero: Number(m.numero),
      tipo_calificacion: 'Moodle y Sistema',
      modulo_programa_universidad_id: m.id,
    });
  }

  if (MODULO_FINAL_NOMBRE) {
    const moduloFinal = await getOrCreateModuloPortal(thiz, MODULO_FINAL_NOMBRE);
    if (!moduloFinal?.id) throw new Error(`No se pudo obtener el módulo final: ${MODULO_FINAL_NOMBRE}`);
    const ultimoNumero = modulos.reduce((max, m) => Math.max(max, Number(m.numero) || 0), 0);
    modulos.push({
      modulo_id: moduloFinal.id,
      numero: ultimoNumero + 1,
      tipo_calificacion: 'Moodle y Sistema',
    });
  }
  return modulos;
};

const obtenerResponsableAcademico = async (sedePortalId) => {
  const base = process.env.VUE_APP_SERVER_TALENTO;
  const resultado = {
    responsable: null,
    advertencia: null,
  };

  if (!base || !sedePortalId) {
    resultado.advertencia = 'No se pudo consultar responsable academico: falta VUE_APP_SERVER_TALENTO o sedePortalId';
    return resultado;
  }

  try {
    const url = `${base}/api/empleado-academico/empleados-por-sede?sedePortalId=${sedePortalId}`;
    const empleados = await fetch(url).then(r => {
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      return r.json();
    });

    if (!Array.isArray(empleados) || !empleados.length) return resultado;

    const ordenados = empleados
      .slice()
      .filter(e => e && e.idPersonaPortal)
      .sort((a, b) => Number(a.nivelPrioridad || 999999) - Number(b.nivelPrioridad || 999999));
    const seleccionado = ordenados[0];
    if (!seleccionado?.idPersonaPortal) return resultado;

    resultado.responsable = {
      responsable_id: seleccionado.idPersonaPortal,
      nombre: seleccionado.nombreCompleto || null,
      empleado_academico_id: seleccionado.id || null,
      nivel_prioridad: seleccionado.nivelPrioridad ?? null,
    };
  } catch (e) {
    resultado.advertencia = `No se pudo obtener responsable academico para sedePortalId ${sedePortalId}: ${e?.message || 'error desconocido'}`;
  }

  return resultado;
};

export const validarProgramasUniversidadParaCrearEsam = async (rows) => {
  const programas = [];
  const errores = [];

  for (const row of rows) {
    const res = await ProgramaUniversidadService.findOne(row.id).catch(() => null);
    const programaUniv = res?.data?.datos;
    const nombre = programaUniv?.programaNombre || row.programaNombre || `ID ${row.id}`;
    const modulos = programaUniv?.modulosProgramasUniversidades || [];
    // por el momento no validamos si tiene lista de precios 
    // const precios = programaUniv?.listasPreciosPorTipo || [];

    const base = {
      etapa: 'validacion',
      programa_universidad_id: row.id,
      programa_universidad_nombre: nombre,
      sede: row.sede ? { id: row.sede.id, nombre: row.sede.nombre } : null,
    };

    if (!programaUniv) errores.push({ ...base, error: `No se pudo cargar el programa universidad ${nombre}` });
    else if (!modulos.length) errores.push({ ...base, error: `Faltan los módulos en el programa universidad ${nombre}` });
    // else if (!precios.length) errores.push({ ...base, error: `Falta la lista de precios en programa universidad ${nombre}` });
    else programas.push({ row, programaUniv });
  }

  return { ok: errores.length === 0, errores, programas };
};

export const crearProgramaEsam = async (thiz, row, programaUniv) => {
  const postgrado = await getOrCreatePostgrado(thiz, row);
  if (!postgrado?.id) throw new Error(`No se encontró o creó el postgrado para ${row.programaNombre}`);

  const version = parseInt(programaUniv.version, 10);

  const programa = {
    version: Number.isNaN(version) ? 0 : version,
    grupo: (programaUniv.programas || []).length + 1,
    gestion: new Date().getFullYear(),
    sede_id: row.sede.id,
  };

  const modulos = await buildModulos(thiz, programaUniv.modulosProgramasUniversidades || []);
  const planes = buildPlanes(programaUniv.listasPreciosPorTipo || []);
  const responsableAcademico = await obtenerResponsableAcademico(programa.sede_id);
  window.console.log('planes omitidos por el momento', planes);
  

  const obj = {
    nombre_compuesto: nombreCompuestoEsam(postgrado, programa, programaUniv, row),
    posgrado_id: postgrado.id,
    xcategoria_id: postgrado.categoria?.id || 1,
    nota_aprobacion: NOTA_APROBACION_DEFAULT,
    version: programa.version,
    grupo: programa.grupo,
    gestion: programa.gestion,
    sede_id: programa.sede_id,
    modalidad: MODALIDAD_ESAM_DEFAULT,
    portada: PORTADA_DEV_DEFAULT,
    fecha_matricula: fmtDate(row.fecha_inicio_campana),
    fecha_inicio: null,
    fecha_fin: null,
    programa_universidad_id: row.id,
    tipo_programa: modalidadProgramaUniversidad(programaUniv),
    modulos,
    modificar_modulos: [],
    planes: [], // por el momento no se envian los planes
    modificar_planes: [],
    universidad_id: programaUniv?.sedeUniversidad?.universidadId || null,
  };

  if (responsableAcademico.responsable?.responsable_id) {
    obj.responsable = { responsable_id: responsableAcademico.responsable.responsable_id };
  }

  const res = await fetch(`${process.env.VUE_APP_API_REST}/esam/programa`, {
    method: 'POST',
    headers: getheadersrest(),
    body: JSON.stringify(obj),
  }).then(r => r.json());

  if (!res?.programa_id) {
    throw new Error(mensajeError(res?.error || res?.data || res) || `No se pudo crear el programa ESAM ${row.programaNombre}`);
  }
  return {
    programa_id: res.programa_id,
    nombre_compuesto: obj.nombre_compuesto,
    sede: row.sede ? { id: row.sede.id, nombre: row.sede.nombre } : null,
    modulos_count: obj.modulos.length,
    planes_count: obj.planes.length,
    responsable: responsableAcademico.responsable,
    responsable_advertencia: responsableAcademico.advertencia,
    programa_universidad_id: row.id,
    programa_universidad_nombre: row.programaNombre,
    payload: obj,
    response: res,
  };
};

const parseJsonSeguro = value => {
  if (!value) return null;
  if (typeof value === 'object') return value;
  try {
    return JSON.parse(value);
  } catch (e) {
    return null;
  }
};

const creadosPrevios = reporteAnterior => {
  const anterior = parseJsonSeguro(reporteAnterior);
  const previos = new Map();
  const creados = anterior?.creados || anterior?.exitosos || [];
  const omitidos = anterior?.omitidos || [];
  creados.forEach(item => {
    const id = item.programa_universidad_id || item.programaUniversidadId;
    if (id) previos.set(Number(id), item);
  });
  omitidos.forEach(item => {
    const id = item.programa_universidad_id || item.programaUniversidadId;
    if (id) previos.set(Number(id), item);
  });
  return previos;
};

export const crearProgramasEsamMasivo = async (thiz, rows, opciones = {}) => {
  const omitidos = [];
  const fallidos = [];
  const creados = [];
  const inicio = new Date().toISOString();
  const previos = creadosPrevios(opciones.aprobadosResponseCreate);
  const pendientes = rows.filter(row => {
    const previo = previos.get(Number(row.id));
    if (!previo) return true;
    omitidos.push({
      programa_universidad_id: row.id,
      programa_universidad_nombre: row.programaNombre,
      programa_id: previo.programa_id || null,
      nombre_compuesto: previo.nombre_compuesto || null,
      sede: previo.sede || (row.sede ? { id: row.sede.id, nombre: row.sede.nombre } : null),
      modulos_count: previo.modulos_count || null,
      planes_count: previo.planes_count || null,
      responsable: previo.responsable || null,
      responsable_advertencia: previo.responsable_advertencia || null,
      motivo: 'Ya fue creado en una ejecución anterior',
    });
    return false;
  });

  const validacion = await validarProgramasUniversidadParaCrearEsam(pendientes);
  validacion.errores.forEach(error => fallidos.push(error));

  for (const item of validacion.programas) {
    try {
      const creado = await crearProgramaEsam(thiz, item.row, item.programaUniv);
      creados.push({
        programa_universidad_id: item.row.id,
        programa_universidad_nombre: item.row.programaNombre,
        programa_id: creado.programa_id,
        nombre_compuesto: creado.nombre_compuesto,
        sede: creado.sede,
        modulos_count: creado.modulos_count,
        planes_count: creado.planes_count,
        responsable: creado.responsable,
        responsable_advertencia: creado.responsable_advertencia,
        response: creado.response,
      });
    } catch (e) {
      fallidos.push({
        etapa: 'creacion',
        programa_universidad_id: item.row.id,
        programa_universidad_nombre: item.row.programaNombre,
        sede: item.row.sede ? { id: item.row.sede.id, nombre: item.row.sede.nombre } : null,
        error: e?.message || 'Error al crear programa ESAM',
      });
    }
  }

  const fin = new Date().toISOString();
  const reporte = {
    inicio,
    fin,
    total_solicitados: rows.length,
    total_pendientes: pendientes.length,
    total_creados: creados.length,
    total_fallidos: fallidos.length,
    total_omitidos: omitidos.length,
    creados,
    fallidos,
    omitidos,
  };

  return {
    ok: fallidos.length === 0,
    errores: fallidos.map(f => f.error),
    creados,
    fallidos,
    omitidos,
    reporte,
  };
};
